import {
  Box,
  Button,
  ChevronDownIcon,
  Flex,
  Hide,
  List,
  Popover,
  TrashIcon,
  Typography,
  useMobileMediaQuery,
} from '@iheartjane/reefer';
import type { PopoverContextProps } from '@iheartjane/reefer';
import { useRef } from 'react';

import styles from './cartProductActions.module.css';

const BUTTON_SIZE = '96px';

interface CartProductActionsProps {
  count: number;
  handleEditQuantity: (qty: number) => void;
  handleRemoveProduct: () => void;
  maxQuantity: number;
  name: string;
}
export const CartProductActions = ({
  handleRemoveProduct,
  handleEditQuantity,
  count,
  name,
  maxQuantity,
}: CartProductActionsProps) => {
  const qtyButtonRef = useRef<HTMLDivElement>(null);
  const isMobile = useMobileMediaQuery({});
  const quantityOptions = Array.from({ length: maxQuantity }, (_, i) => i + 1);

  return (
    <Flex
      ml="auto"
      width="100%"
      justifyContent="space-between"
      alignSelf="flex-end"
      maxWidth={isMobile ? '100%' : '160px'}
    >
      <Box width={isMobile ? BUTTON_SIZE : '48px'} mr={16}>
        <Button.Icon
          full
          icon={<TrashIcon altText={`remove ${name}`} />}
          onClick={handleRemoveProduct}
          variant="tertiary"
          data-testid="remove-cart-item"
        />
      </Box>
      <Flex width={isMobile ? '100%' : BUTTON_SIZE} grow basis="0">
        <Hide isHidden aria-live="polite" aria-atomic="true">
          {`Qty: ${count}`}
        </Hide>
        <Popover
          label={`Select quantity for ${name}`}
          disableMobileStyling
          alignment={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          target={
            <div ref={qtyButtonRef} tabIndex={-1}>
              <Button
                className={styles['quantityButton']}
                full
                label={count.toString()}
                variant="tertiary"
                endIcon={<ChevronDownIcon size="sm" />}
              />
            </div>
          }
          targetWidth="100%"
        >
          {({ closePopover }: PopoverContextProps) => (
            <Popover.Content padding={false} maxHeight={265}>
              <List label="quantity selector">
                {quantityOptions.map((qty) => (
                  <List.Item
                    ariaLabel={qty.toString()}
                    onClick={() => {
                      handleEditQuantity(qty);
                      closePopover();
                      qtyButtonRef.current?.focus();
                    }}
                    key={qty}
                    px={16}
                  >
                    <Typography>{qty}</Typography>
                  </List.Item>
                ))}
              </List>
            </Popover.Content>
          )}
        </Popover>
      </Flex>
    </Flex>
  );
};
